import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

import { getEnvConfig } from './validateEnv';

const env = getEnvConfig();

const firebaseConfig = {
    apiKey: env.FIREBASE_API_KEY,
    authDomain: env.FIREBASE_AUTH_DOMAIN,
    databaseURL: env.FIREBASE_DATABASE_URL,
    projectId: env.FIREBASE_PROJECT_ID,
    storageBucket: env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID,
    appId: env.FIREBASE_APP_ID,
    measurementId: env.FIREBASE_MEASUREMENT_ID
};

// Robust initialization for Hot Reload environments
let app: FirebaseApp;
if (!getApps().length) {
    app = initializeApp(firebaseConfig);
} else {
    app = getApp();
}
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
auth.useDeviceLanguage();

// Initialize Firestore
export const db = getFirestore(app);

// Enable persistence only in production to avoid hot-reload assertion errors (ve:-1)
if (process.env.NODE_ENV === 'production') {
    enableMultiTabIndexedDbPersistence(db).catch((err) => {
        if (err.code !== 'failed-precondition') {
            console.warn('Failed to enable persistence:', err);
        }
    });
}

export const storage = getStorage(app);
export const functions = getFunctions(app);

export const CONFIG = {
    MAPS_API_KEY: env.GOOGLE_MAPS_API_KEY || '',
    RAZORPAY_KEY_ID: env.RAZORPAY_KEY_ID || ''
};
